// Jest does not support import.meta — use process.env in non-browser environments.
const env: Record<string, string | undefined> = typeof process !== 'undefined' ? process.env : {};
const debugLogsEnabled =
  env['VITE_DEBUG_LOGS'] === 'true' ||
  env['DEBUG_LOGS'] === 'true';

const isDev =
  typeof process !== 'undefined' && env['NODE_ENV'] !== 'production';

export const devLog: (...args: unknown[]) => void = isDev
  ? (...args) => {
      if (debugLogsEnabled) console.log(...args);
    }
  : () => {};

export const devWarn: (...args: unknown[]) => void = isDev
  ? (...args) => {
      if (debugLogsEnabled) console.warn(...args);
    }
  : () => {};

export const devError: (...args: unknown[]) => void = isDev
  ? (...args) => {
      if (debugLogsEnabled) console.error(...args);
    }
  : () => {};
